































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Unit from "../../../store/entities/unit";
@Component
export default class CreateUnit extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  unit: Unit = new Unit();
  isClient() {
    return !Util.isNull(this.$store.state.session.client);
  }
  get client() {
    return this.$store.state.session.client;
  }
  save() {
    if (this.isClient()) this.unit.clientCode = this.client.code;
    (this.$refs.unitForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "unit/create",
          data: this.unit,
        });
        Util.showSuccessMsg(this, "Success.CreateUnitSucc");
        (this.$refs.unitForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.unitForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  unitRule = {
    code: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Code")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
  };
}
